<template>
    <v-dialog :value="exibirModal && requisicaoEditar" persistent :max-width="'550'">
        <v-card>
            <v-card-title class="primary modal-title" primary-title>
                <span>
                    Alterar Id Compra Direta
                </span>
            </v-card-title>
            <v-card-text v-if="requisicaoEditar">
                <span>
                    Escreva um id para a compra direta {{requisicaoEditar.compraDiretaId}}:
                </span>

                <br>
                <br>

                <v-text-field label="Compra Direta" :name="'Processo id ' + requisicaoEditar.compraDiretaId" class="required-field"
                              :key="'Compra Direta id '  + requisicaoEditar.compraDiretaId" placeholder="Ex. 1"
                              :error-messages="errors.collect('Compra Direta id '  + requisicaoEditar.compraDiretaId)"
                              v-model="id" v-validate="'required|regex:^\\d{1,19}$'" maxlength="19" type="text"
                              @keydown="apenasNumeros" @input="validarLimiteLong"/>

            </v-card-text>

            <v-card-actions>
                <v-flex>
                    <div class="lista-opcoes__acao">
                        <az-call-to-action id="botaoConfirmar"
                                           @click="$emit('cancelar')"
                                           css-class="botao" class="ma-2 py-2"
                                           slot="actions">
                            Cancelar
                        </az-call-to-action>
                        <az-call-to-action id="botaoFechar"
                                           @click="confirmar()"
                                           css-class="botao-desativado" class="ma-2 py-2"
                                           slot="actions">
                            Confirmar
                        </az-call-to-action>
                    </div>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ModalEditarProcessoRequisicao',
    props: {
        exibirModal:{
            type: Boolean,
            default: false
        },
        requisicaoEditar:{
            type: Object,
            default: null,
        }
    },
    data(){
        return{
            id: null
        }
    },
    mounted(){
        this.id = this.requisicaoEditar.compraDiretaId
    },
    methods:{
        confirmar() {
            if(!this.id){
                throw new Error('Id não informado!')
            }
            this.requisicaoEditar.compraDiretaId = this.id
            this.$emit('confirmar', this.requisicaoEditar)
        },
        apenasNumeros(e) {
            const permitidas = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab']
            if (!/^\d$/.test(e.key) && !permitidas.includes(e.key)) {
                e.preventDefault()
            }
        },
        validarLimiteLong(valorDigitado) {
            const valor = String(valorDigitado).replace(/\D/g, '')
            const maxLong = '9223372036854775807'

            if (valor.length > 19 || (valor.length === 19 && valor > maxLong)) {
                this.id = maxLong
            } else {
                this.id = valor
            }
        }
    }
}
</script>

<style scoped lang="stylus">
    .lista-opcoes
        text-align center

        &__acao
            display flex
            justify-content space-between
            text-align center

    .botao-desativado
        color #777 !important

</style>
